import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

const BASE_URL = `${process.env.REACT_APP_API_URL_AUTH}`;

const apiGetFromAuth = (
  url: string,
  config: AxiosRequestConfig = {}
) => {
  const authCook = Cookies.get("access_token");

  const axiosConfig: AxiosRequestConfig = {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authCook}`,
      ...(config.headers || {}), //NOSONAR
    },
    ...config, 
  };

  return axios.get(`${BASE_URL}${url}`, axiosConfig);
};

export default apiGetFromAuth;
